/**
 * @generated SignedSource<<9b950bb9dc3d2c32f816875b13c59ab1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedDescriptionAdditionalOptions_item$data = {
  readonly attributes: {
    readonly customizable: ReadonlyArray<{
      readonly option: {
        readonly serviceId: string | null;
      } | null;
      readonly text: string | null;
    } | null> | null;
    readonly ringResizable: ReadonlyArray<{
      readonly option: {
        readonly serviceId: string | null;
      } | null;
    } | null> | null;
  } | null;
  readonly isCustomizable: boolean | null;
  readonly isDyoCustomizable: boolean | null;
  readonly isJewelry: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptionsContent_item">;
  readonly " $fragmentType": "PdpSharedDescriptionAdditionalOptions_item";
};
export type PdpSharedDescriptionAdditionalOptions_item$key = {
  readonly " $data"?: PdpSharedDescriptionAdditionalOptions_item$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDescriptionAdditionalOptions_item">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "concreteType": "AttributeOption",
  "kind": "LinkedField",
  "name": "option",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "serviceId",
      "storageKey": null
    }
  ],
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDescriptionAdditionalOptions_item",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDescriptionAdditionalOptionsContent_item"
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isJewelry",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isDyoCustomizable",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ItemAttributes",
      "kind": "LinkedField",
      "name": "attributes",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "customizable",
          "plural": true,
          "selections": [
            (v0/*: any*/),
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "text",
              "storageKey": null
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "AttributeValue",
          "kind": "LinkedField",
          "name": "ringResizable",
          "plural": true,
          "selections": [
            (v0/*: any*/)
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Item",
  "abstractKey": null
};
})();

(node as any).hash = "72d221ed0c2dc3b6356c6de553c4a8ac";

export default node;
